// extracted by mini-css-extract-plugin
export default {"title":"FormTitle_title__s8aTN"};